"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProbingFormPreview = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _Button = require("../Button");
var _getPrefixCls = require("../../utils/getPrefixCls");
var _Text = require("../Text");
var _Popup = require("../Popup");
var _ = require(".");
var _probing_form = _interopRequireDefault(require("../../assets/images/probing_form.svg"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var ProbingFormPreview = function ProbingFormPreview(props) {
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    active = _useState2[0],
    setActive = _useState2[1];
  var title = props.title,
    _props$formList = props.formList,
    formList = _props$formList === void 0 ? [] : _props$formList,
    buttonText = props.buttonText,
    popupProps = props.popupProps,
    probingFormProps = props.probingFormProps;
  var PREFIX = (0, _getPrefixCls.getPrefixCls)('probing-form-preview');
  var showPopup = function showPopup() {
    setActive(true);
  };
  var closePopup = function closePopup() {
    setActive(false);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: PREFIX
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-content")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-title")
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "".concat(PREFIX, "-icon"),
    src: _probing_form.default
  }), /*#__PURE__*/_react.default.createElement("span", null, title)), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-list")
  }, formList.map(function (formItem) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(PREFIX, "-list-item")
    }, /*#__PURE__*/_react.default.createElement(_Text.Text, {
      block: false,
      content: formItem.value,
      maxLines: formItem.maxLines || 1,
      title: {
        block: false,
        content: "".concat(formItem.title, ": ")
      }
    }));
  }))), /*#__PURE__*/_react.default.createElement(_Button.Button, {
    text: buttonText,
    onClick: showPopup
  }), /*#__PURE__*/_react.default.createElement(_Popup.Popup, (0, _extends2.default)({
    showCloseIcon: true
  }, popupProps, {
    titleClassName: "".concat(PREFIX, "-popup-title"),
    active: active,
    onClose: closePopup
  }), /*#__PURE__*/_react.default.createElement(_.ProbingForm, (0, _extends2.default)({
    readOnly: true
  }, probingFormProps))));
};
exports.ProbingFormPreview = ProbingFormPreview;